import { useReducer } from 'react';

export const DEFAULT_PAGE_SIZE = 10;

export const initialStateDefault = {
  pagination: {
    page: 0,
    size: DEFAULT_PAGE_SIZE,
  },
  filter: {},
  query: {},
  sort: [],
};

function pageFilterSortReducer(state, action) {
  switch (action.type) {
    case 'setPagination':
      return { ...state, pagination: action.payload };
    case 'setFilter':
      return { ...state, pagination: { ...state.pagination, page: 0 }, filter: action.payload };
    case 'setQuery':
      return { ...state, pagination: { ...state.pagination, page: 0 }, query: action.payload };
    case 'setSort':
      return { ...state, pagination: { ...state.pagination, page: 0 }, sort: action.payload };
    default:
      return state;
  }
}

export function usePageFilterSortReducer(initialState = initialStateDefault) {
  return useReducer(pageFilterSortReducer, initialState);
}
